import { Component, HostListener } from '@angular/core';
import { DragScrollComponent } from 'ngx-drag-scroll';

@Component({
  selector: 'drag-scroll-x',
  template: `
    <div class="drag-scroll-content" #contentRef>
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      :host {
        overflow: hidden;
        display: block;
      }
      .drag-scroll-content {
        height: auto !important;
        min-height: calc(100vh - 56px);
        overflow: auto;
        white-space: nowrap;
      }
    `
  ]
})
export class DragScrollExtendedComponent extends DragScrollComponent {
  /**
   *
   * hacky way to enforce a resize on drag-scroll-component when window resizes.
   * look out for a future release that supports window.resize.
   */
  @HostListener('window:scroll', [])
  onWindowResize() {
    const drag: any = this;
    drag.markElDimension();
    drag._renderer.setStyle(
      drag._contentRef.nativeElement,
      'width',
      drag.elWidth
    );
    drag._renderer.setStyle(
      drag._contentRef.nativeElement,
      'height',
      drag.elHeight
    );
  }
}
``